import { EndEstado } from './../../model/endereco/endEstado';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '../generics/generic.service';
import { AutoRegisterService } from '../generics/servicesRegistry';

@Injectable({
  providedIn: 'root'
})

@AutoRegisterService()
export class EndEstadoService extends GenericService<EndEstado>{
  constructor(http: HttpClient) { 
    super(http);
    super.initResource("endestado")
  }
}
